import { render, staticRenderFns } from "./FrontOfLicenseDesktopSvg.vue?vue&type=template&id=0d19fbaf&"
import script from "./FrontOfLicenseDesktopSvg.vue?vue&type=script&lang=ts&"
export * from "./FrontOfLicenseDesktopSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports